<!-- =========================================================================================
    File Name: FormWizardNumberTab.vue
    Description: Form wizard with numbers in tabs
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vx-card title="Formulário de Solicitação">


        <div class="mt-1">
            <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Solicitar" @on-complete="formSubmitted">
                <tab-content title="Empresa" class="mb-5">

                    <!-- tab 1 content -->
                    <div class="vx-row">
                        <div class="vx-col w-1/2 mt-5">
                            <vs-select v-model="num_func" class="w-full select-large" label="Número de Empregados">
                                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in funcionarios" class="w-full" />
                            </vs-select>
                        </div>
                        <div class="vx-col w-1/2 mt-5">
                            <vs-input label="Página Web"  v-model="pagina_web" class="w-full" />
                        </div>
                        <div class="vx-col w-full">
                            <vs-textarea v-model="descricao_empresa" label="Descrição da empresa" class="mb-0 mt-10" rows="3" />
                        </div>
                        <div class="vx-col w-1/2 mt-5">
                            <vs-input type="text" label="Facebook"  v-model="facebook" class="w-full" />
                        </div>
                        <div class="vx-col w-1/2 mt-5">
                            <vs-input type="text" label="Instagram"  v-model="instagram" class="w-full" />
                        </div>
                        <div class="vx-col w-2/3 mt-5">
                            <vs-input type="text" label="Endereço"  v-model="endereco" class="w-full" />
                        </div>
                        <div class="vx-col w-1/3 mt-5">
                            <vs-input type="text" label="Número"  v-model="numero" class="w-full" />
                        </div>
                        <div class="vx-col w-1/2 mt-5">
                            <vs-input type="text" label="Cidade"  v-model="cidade" class="w-full" />
                        </div>
                        <div class="vx-col w-1/2 mt-5">
                            <vs-input type="text" label="Bairro"  v-model="bairro" class="w-full" />
                        </div>
                        <div class="vx-col w-1/3 mt-5">
                            <vs-input type="text" label="Estado"  v-model="estado" class="w-full" />
                        </div>
                    </div>
                </tab-content>

                <!-- tab 2 content -->
                <tab-content title="Crédito" class="mb-5">
                    <div class="vx-row">
                        <div class="vx-col w-1/2">
                            <vs-input name="price" v-model.lazy="price" v-money="money" label="Valor do Crédito" class="w-full" />
                        </div>
                        <div class="vx-col w-1/2">
                            <vs-select v-model="num_parcelas" class="w-full select-large" label="Parcelas">
                                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in parcelas" class="w-full" />
                            </vs-select>
                        </div>
                        <div class="vx-col w-full">
                            <vs-textarea v-model="descricao_credito" label="Descrição da útilização do crédito." class="mb-0 mt-10" rows="3" />
                        </div>
                    </div>
                </tab-content>

                <!-- tab 3 content -->
                <tab-content title="Adicional" class="mb-5">
                    <div class="vx-row">
                        <vx-card title="Perfil" class="mt-2">
        
                          <p>Uma foto de perfil ou logomarca da sua empresa, ajuda na visibilidade:</p>

                          <vs-alert color="primary" icon="new_releases" active="true" class="mt-1">
                              Adicione a foto no campo abaixo
                          </vs-alert>

                          <div class="mt-1">
                              <vs-upload limit="1" :action="url_contrato" @on-success="successUpload" @on-error="errorUpload" />
                          </div>


                      </vx-card>
                    </div>
                </tab-content>
            </form-wizard>
        </div>

        
    </vx-card>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import {VMoney} from 'v-money'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
    data() {
        return {

            url_contrato: this.$store.state.API_URL+'documentos/upload/perfil/'+localStorage.getItem("token"),
            funcionarios: [
                {text: "1-10", value:"1-10"},
                {text: "11-50", value:"11-50"},
                {text: "51-100", value:"51-100"},
                {text: "100-1000", value:"100-1000"},
            ],
            parcelas: [
                {text: "8x", value:"8"},
                {text: "12x", value:"12"},
                {text: "13x", value:"13"},
                {text: "14x", value:"14"},
                {text: "15x", value:"15"},
                {text: "16x", value:"16"},
                {text: "17x", value:"17"},
                {text: "18x", value:"18"},
                {text: "19x", value:"19"},
                {text: "20x", value:"20"},
                {text: "21x", value:"21"},
                {text: "22x", value:"22"},
                {text: "23x", value:"23"},
                {text: "24x", value:"24"},
            ],
            categoria: this.$route.params.item_id,
            num_parcelas: "8",
            num_func: "1-10",
            pagina_web: "", 
            facebook: "", 
            instagram: "", 
            price: 0,
            money: {
              decimal: ',',
              thousands: '.',
              prefix: 'R$ ',
              suffix: '',
              precision: 2,
              masked: false /* doesn't work with directive */
            },
            descricao_empresa: "",
            descricao_credito: "",
            endereco: "",
            numero: "",
            estado: "",
            bairro: "",
            cidade: "",
        }
    },
    methods: {
        successUpload(retorn) {
            console.log(retorn.target.response);
            var dados = JSON.parse(retorn.target.response);
            this.$vs.notify({ color: 'success', title: 'Status', text: dados.message })
        },
        errorUpload(retorn) {
            console.log(retorn.target.response);
            var dados = JSON.parse(retorn.target.response);
            this.$vs.notify({ color: 'danger', title: 'Status', text: dados.message })
        },
        formSubmitted() {
            var valore = this.roundToXDigits(this.parseNumber(this.price), 2);
            if(this.roundToXDigits(this.parseNumber(this.price), 2) < 1000)
              return alert('Valor mínimo: R$ 1.000,00');
            fetch(this.$store.state.API_URL+'P2P/Investimento/Solicitar', {
              method: 'POST',
              headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
              body: "token="+localStorage.getItem("token")+"&funcionarios="+this.num_func+"&parcelas="+this.num_parcelas+"&pagina_web="+this.pagina_web+"&facebook="+this.facebook+"&instagram="+this.instagram+"&descricao_credito="+this.descricao_credito+"&descricao_empresa="+this.descricao_empresa+"&endereco="+this.endereco+"&numero="+this.numero+"&estado="+this.estado+"&bairro="+this.bairro+"&cidade="+this.cidade+"&price="+valore+"&categoria="+this.categoria
            })
            .then((response) => response.text())
            .then((responseData) => {

              var dados = JSON.parse(responseData);
              if(dados.done == false)
              {
                this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: dados.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        });
              }
              else if(dados.done == true)
              {
                this.$router.push('/p2p/investimento/proposta/'+dados.hash);
              }
            })
            .catch((error) => {

              this.$vs.notify({
                time: 2500,
                title: 'Error',
                text: "Verifique a sua conexão.",
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            });
        },
        roundToXDigits(value, digits)
        {
          if (!digits) {
            digits = 2;
          }

          value = value * Math.pow(10, digits);
          value = Math.round(value);
          value = value / Math.pow(10, digits);

          return value;
        },
        parseNumber(strg) {
          var strg = strg || "";
          var decimal = '.';
          strg = strg.replace(/[^0-9$.,]/g, '');
          strg = strg.replace('R', '');
          strg = strg.replace('$', '');
          strg = strg.replace(' ', '');
          if(strg.indexOf(',') > strg.indexOf('.')) decimal = ',';
          if((strg.match(new RegExp("\\" + decimal,"g")) || []).length > 1) decimal="";
          if (decimal != "" && (strg.length - strg.indexOf(decimal) - 1 == 3) && strg.indexOf("0" + decimal)!==0) decimal = "";
          strg = strg.replace(new RegExp("[^0-9$" + decimal + "]","g"), "");
          strg = strg.replace(',', '.');
          return parseFloat(strg);
        },
    },
    components: {
        FormWizard,
        TabContent
    },
    directives: {money: VMoney}
}
</script>
